(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FormsDialogController', FormsDialogController);

    FormsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Forms'];

    function FormsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Forms) {
        var vm = this;

        vm.forms = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.kbSize = DataUtils.kbSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

      /*  vm.forms.docvisibility = vm.forms.docvisibility+"";*/

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.forms.filesize  = vm.kbSize(vm.forms.fileupload);
            /*vm.forms.docvisibility = parseInt(vm.forms.docvisibility);*/
            if (vm.forms.id !== null) {
                Forms.update(vm.forms, onSaveSuccess, onSaveError);
            } else {
                Forms.save(vm.forms, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:formsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
            /*vm.forms.docvisibility = vm.forms.docvisibility+"";*/
        }


        vm.setFileupload = function ($file, forms) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        forms.fileupload = base64Data;
                        forms.fileuploadContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.uploaddate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
